import { BaseSubscriptionArgs } from '@app/common/src/components/PaymentModal/PaymentModal.utils'
import { Stripe } from '@stripe/stripe-js'
import { confirmPaymentIntentSetupIntent } from '@app/common/src/components/PlanPurchaseExperience/utils/confirmPaymentIntentSetupIntent'
import { confirmationRedirectURL } from '@app/common/src/components/PlanPurchaseExperience/utils/subscriptionService.constant'
import { convertExtraDetailsToUpgradeExtraDetails } from '@dtx-company/inter-app/src/api/subscription-service/types/UpdateSubscriptionPlanExtra'
import { createSubscriptionV3 } from '@dtx-company/inter-app/src/api/subscription-service/createSubscriptionV3'
import { upgradeSubscriptionV3 } from '@dtx-company/inter-app/src/api/subscription-service/upgradeSubscriptionV3'

interface BuySubscriptionV3Args extends BaseSubscriptionArgs {
  paymentMethodType?: string
  paymentMethodId?: string
  subscriptionId?: string
  stripe?: Stripe | null
  trialPeriodDays?: number
}

export const buySubscriptionV3 = async ({
  paymentMethodId,
  promoCode,
  planExtraDetails,
  orgName,
  stripe,
  subscriptionId,
  token,
  selectedPlanId,
  paymentMethodType,
  trialPeriodDays
}: BuySubscriptionV3Args): Promise<string | undefined> => {
  let res
  if (subscriptionId && selectedPlanId) {
    res = await upgradeSubscriptionV3(
      {
        orgName,
        subscriptionId: subscriptionId,
        planId: selectedPlanId,
        paymentMethodId,
        couponCode: promoCode,
        planExtras: convertExtraDetailsToUpgradeExtraDetails(planExtraDetails)
      },
      token
    )
  } else {
    res = await createSubscriptionV3({
      token: token,
      planId: selectedPlanId,
      paymentMethodId,
      couponCode: promoCode,
      orgName: orgName,
      planExtras: convertExtraDetailsToUpgradeExtraDetails(planExtraDetails),
      trialPeriodDays
    })
  }
  if (
    res?.clientSecret &&
    res.clientSecret.intentStatus !== 'succeeded' &&
    res.clientSecret.intentStatus !== 'processing' &&
    stripe
  ) {
    await confirmPaymentIntentSetupIntent(
      res.clientSecret,
      stripe,
      confirmationRedirectURL,
      paymentMethodType || 'card'
    )
  }
  return subscriptionId || res?.subscriptionId
}
